
import React, {Component} from 'react';
import {Tab, Tabs} from 'material-ui';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import EditLabelIcon from 'material-ui-icons/BorderColor';
import TranslateLabelIcon from 'material-ui-icons/Translate';
import ViewLabelIcon from 'material-ui-icons/Visibility';
import StaffEditContent from './StaffEditContent';
import StaffView from './StaffView';
import StaffTranslationsList from './translations/StaffTranslationsIndex';
import {setStaffTab} from '../layout/actions';
import {
    fetchStaffMember,
    fetchStaffTranslations
} from './thunks';
import {
    canEditOrViewGlobal
} from '../../components/permissions/permissions';

const EditStaffActiveTab = (props) => (<StaffEditContent label={props.staff} />)
const ViewLStaffActiveTab = (props) => (<StaffView label={props.staff} />)
let EditOrViewStaffActiveTab = canEditOrViewGlobal(EditStaffActiveTab, ViewLStaffActiveTab);

class StaffEditTabs extends Component {

    componentWillMount() {
        this.props.fetchStaffMember(this.props.match.params.id);
        this.props.fetchStaffTranslations(this.props.match.params.id);
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleChange = (event, value) => {
        this.props.setStaffTab(value, this.props.match.params.id);
    };

    render() {

        const {
            activeTabData,
            staffMember,
        } = this.props;

        let activeTab = 0;

        if (activeTabData[this.props.match.params.id]) {
            activeTab = activeTabData[this.props.match.params.id];
        }

        const EditStaffTab = () => (
            <Tabs
                value={activeTab}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab icon={<EditLabelIcon />} label="Edit staff member" />
                <Tab icon={<TranslateLabelIcon />} label="Translations" />
            </Tabs>
        )

        const ViewStaffTab = () => (
            <Tabs
                value={activeTab}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab icon={<ViewLabelIcon />} label="View Staff" />
                <Tab icon={<TranslateLabelIcon />} label="Translations" />
            </Tabs>
        )

        let EditOrViewStaffTab = canEditOrViewGlobal(EditStaffTab, ViewStaffTab);

        return (
            <div>
                <EditOrViewStaffTab />
                {activeTab === 0 && staffMember &&
                    <EditOrViewStaffActiveTab
                        staffMember={staffMember}
                    />
                }
                {activeTab === 1 && staffMember &&
                    <StaffTranslationsList
                        staffMember={staffMember}
                        staffId={staffMember.id}
                    />
                }
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    activeTabData: state.layout.activeStaffTab,
    staffMember: state.staff.staffMember,
    staffTranslations: state.staff.staffTranslations,
});

export default connect(mapStateToProps, {
    setStaffTab,
    fetchStaffMember,
    fetchStaffTranslations
})(StaffEditTabs);



// WEBPACK FOOTER //
// ./src/containers/staff/StaffEditTabs.jsx